import { render } from "./ProfileMarkQuestionContent.vue?vue&type=template&id=6143ae2c&scoped=true"
import script from "./ProfileMarkQuestionContent.vue?vue&type=script&lang=js"
export * from "./ProfileMarkQuestionContent.vue?vue&type=script&lang=js"

import "./ProfileMarkQuestionContent.vue?vue&type=style&index=0&id=6143ae2c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6143ae2c"]])

export default __exports__